module.exports = __webpack_public_path__ + "img/car.bad97f24.png";